import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_FILE_SPREADSHEET: GlameraIconDefinition = {
  name: 'file-spreadsheet',
  viewBox: '0 0 24 24',
  svg: `
    <g class="glm-file-spreadsheet-body">
      <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
      <path d="M14 2v5a1 1 0 0 0 1 1h5"></path>
      <path class="glm-file-spreadsheet-cell glm-file-spreadsheet-cell-1" d="M8 13h2"></path>
      <path class="glm-file-spreadsheet-cell glm-file-spreadsheet-cell-2" d="M14 13h2"></path>
      <path class="glm-file-spreadsheet-cell glm-file-spreadsheet-cell-3" d="M8 17h2"></path>
      <path class="glm-file-spreadsheet-cell glm-file-spreadsheet-cell-4" d="M14 17h2"></path>
    </g>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-file-spreadsheet-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './file-spreadsheet.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class FileSpreadsheetIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_FILE_SPREADSHEET;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
